import { Box, Checkbox, CircularProgress, Paper } from '@mui/material';
import React, { useEffect, useState } from 'react';
import DataList from '../../sharedcomponents/dataList/dataList';
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
import { makeStyles } from '@mui/styles';
import Helper from '../../utility/helper';
import RouteConstants from '../../constants/routeConstants';
import axios from 'axios';

const useStyles = makeStyles(() => ({
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
}));

const ContactList = () => {
    const classes = useStyles();
    const [contactListData, setContactListData] = useState([]);
    const [globalData, setGlobalData] = useState([]);
    const [contactListRawData, setContactListRawData] = useState([]);
    const [loading, setLoading] = useState(true);
    const eventInfo = Helper.getStorage('eventInfo');
    const userInfo = Helper.getStorage('userInfo');
    const [checked, setChecked] = useState(true);
    const [connectionCount, setConnectionCount] = useState(0);
    const [userActivityPDFLoader, setUserActivityPDFLoader] = React.useState(false);
    const [snackBarProps, setSnackBarProps] = useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const [alphabet, setAlphabet] = useState('')
    const [currentAlpha, setCurrentAlpha] = useState('')
    useEffect(() => {
        getModuleConfig()
        getAlphabet()
    }, [])
    const getAlphabet = () => {
        let alpha = []
        for (let i = 65; i <= 90; i++) {
            alpha.push(String.fromCharCode(i))
        }
        setAlphabet(alpha);
    }
    const getModuleConfig = () => {
        const ModuleID = 30;
        const type = "ConnectionCount";

        ApiHelper.get(APIURLConstants.GET_MODULE_CONFIG(ModuleID, type))
            .then((res) => {
                let data = res.data && res.data.length > 0 ? res.data.find(i => i.eventID === eventInfo.eventID) : null;
                if (data) {
                    setLoading(false)
                    setConnectionCount(Number(data.value))
                    getParticipantList(checked, Number(data.value))
                } else {
                    setLoading(false)
                }
            })
            .catch((error) => {
                setLoading(false)
                console.error('Error fetching data:', error);
            });
    };

    const getParticipantList = (params, count) => {
        ApiHelper.get(
            APIURLConstants.GET_CONTACT_LIST(
                eventInfo.eventID
            )
        )
            .then(async (res) => {
                if (res.data) {
                    setLoading(false)
                    if (res.data.length > 0) {
                        setContactListRawData(res.data)
                        getContactListData(res.data, params, count)
                    }
                }
            }).catch((err) => {
                setLoading(false)
                console.log("err", err);
            }
            )
    }
    const getContactListData = (data, check, count) => {
        if (data.length > 0) {
            let rowData = data;
            let usersData = [];
            let dynamicWidth = 0.8 / count;
            rowData.map((item) => {
                usersData.push({
                    actualData: item,
                    row: [
                        {
                            label: 'Name',
                            key: 'name',
                            name: item.participantName,
                            showLabel: false,
                            width: '0.2',
                            inColumn: true,
                            toEmail: item.participantEmail,
                            showEmail: true,
                            showEmailIcons: true,
                            showContactNo: true,
                            toContactNo: item.contactNo,
                        },
                        {
                            label: 'Conection 1',
                            key: 'name',
                            name: item.connection1,
                            width: String(dynamicWidth),
                            inColumn: true,
                            toEmail: item.connection1Email,
                            showEmail: check ? true : false,
                            showEmailIcons: true,
                            // showLabel: true,
                            showContactNo: true,
                            toContactNo: item.connection1ContactNo,
                        },

                        {
                            label: 'Conection 2',
                            key: 'name',
                            name: item.connection2,
                            width: String(dynamicWidth),
                            inColumn: true,
                            toEmail: item.connection2Email,
                            showEmail: check ? true : false,
                            showEmailIcons: true,
                            showContactNo: true,
                            toContactNo: item.connection2ContactNo,
                            // showLabel: true,
                        },
                        {
                            label: 'Conection 3',
                            key: 'name',
                            name: item.connection3,
                            width: String(dynamicWidth),
                            inColumn: true,
                            toEmail: item.connection3Email,
                            showEmail: check ? true : false,
                            showEmailIcons: true,
                            showContactNo: true,
                            toContactNo: item.connection3ContactNo,
                            // showLabel: true,
                        },
                        {
                            label: 'Conection 4',
                            key: 'name',
                            name: item.connection4,
                            width: String(dynamicWidth),
                            inColumn: true,
                            toEmail: item.connection4Email,
                            showEmail: check ? true : false,
                            showEmailIcons: true,
                            showContactNo: true,
                            toContactNo: item.connection4ContactNo,
                            // showLabel: true,
                        },
                        {
                            label: 'Conection 5',
                            key: 'name',
                            name: item.connection5,
                            width: String(dynamicWidth),
                            inColumn: true,
                            toEmail: item.connection5Email,
                            showEmail: check ? true : false,
                            showEmailIcons: true,
                            showContactNo: true,
                            toContactNo: item.connection5ContactNo,
                            // showLabel: true,
                        },
                        {
                            label: 'Conection 6',
                            key: 'name',
                            name: item.connection6,
                            width: String(dynamicWidth),
                            inColumn: true,
                            toEmail: item.connection6Email,
                            showEmail: check ? true : false,
                            showEmailIcons: true,
                            showContactNo: true,
                            toContactNo: item.connection6ContactNo,
                            // showLabel: false,
                        },
                        {
                            label: 'Conection 7',
                            key: 'name',
                            name: item.connection7,
                            width: String(dynamicWidth),
                            inColumn: true,
                            toEmail: item.connection7Email,
                            showEmail: check ? true : false,
                            showEmailIcons: true,
                            showContactNo: true,
                            toContactNo: item.connection7ContactNo,
                            // showLabel: false,
                        },
                        {
                            label: 'Conection 8',
                            key: 'name',
                            name: item.connection8,
                            width: String(dynamicWidth),
                            inColumn: true,
                            toEmail: item.connection8Email,
                            showEmail: check ? true : false,
                            showEmailIcons: true,
                            showContactNo: true,
                            toContactNo: item.connection8ContactNo,
                            // showLabel: false,
                        },
                        {
                            label: 'Conection 9',
                            key: 'name',
                            name: item.connection9,
                            width: String(dynamicWidth),
                            inColumn: true,
                            toEmail: item.connection9Email,
                            showEmail: check ? true : false,
                            showEmailIcons: true,
                            showContactNo: true,
                            toContactNo: item.connection9ContactNo,
                            // showLabel: false,
                        },
                        {
                            label: 'Conection 10',
                            key: 'name',
                            name: item.connection10,
                            width: String(dynamicWidth),
                            inColumn: true,
                            toEmail: item.connection10Email,
                            showEmail: check ? true : false,
                            showEmailIcons: true,
                            showContactNo: true,
                            toContactNo: item.connection10ContactNo,
                            // showLabel: false,
                        },
                    ],
                });
            });
            usersData.map((val) => {
                val.row = val.row.slice(0, count + 1)
            })
            setGlobalData(usersData)
            setContactListData(usersData)
        }
    }
    const onCheckedChange = (val) => {
        setChecked(val.target.checked)
        getContactListData(contactListRawData, val.target.checked, connectionCount)
    }

    const handleSelectedExportToPDF = () => {
        setUserActivityPDFLoader(true)
        const eventInfo = Helper.getStorage('eventInfo');
        axios.get(window.location.origin + "/" + APIURLConstants.DOWNLOAD_PARTICIPANT_CONNECTION(
            eventInfo.eventID,
            '0',
            true
        ), { headers: { 'Authorization': `Bearer ${Helper.getStorage('accessToken')}` }, responseType: 'blob' })
            .then((res) => {
                saveAs.saveAs(res.data, "ConnectionList.pdf")
                setUserActivityPDFLoader(false)
            })
            .catch((err) => {
                setUserActivityPDFLoader(false);
                setSnackBarProps({
                    snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'Please try after some time.',
                });
                console.log(err);
            });
    };
    const clickAlphabet = (val, i) => {
        // let modifyList = [];
        setCurrentAlpha(val)
        // const filtered = contactListData.filter((item) => {            
        //     return item.actualData.participantName.toLowerCase().startsWith(val.toLowerCase());
        //   });
        const filtered1 = globalData.filter((item) => {
            return item.actualData.participantName.toLowerCase().startsWith(val.toLowerCase());
        });
        //   console.log('contactListData',contactListData,"filtered",filtered, globalData,filtered1);

        // contactListData.forEach((item) => {
        //     let data = item.actualData;
        //     let keys = Object.keys(data);
        //     keys.forEach((key) => {
        //         if (
        //             typeof data[key] === 'string' &&
        //             data[key].toLowerCase().indexOf(val.toLowerCase()) >
        //             -1
        //         ) {
        //             if (modifyList.indexOf(item) == -1)
        //                 modifyList.push(item);
        //         }
        //     });
        // });       
        setContactListData(filtered1)
    }
    const handleReset = () => {
        setCurrentAlpha('')
        getParticipantList(checked, connectionCount)
    }
    const callExport = () => {
        ApiHelper.post(
            APIURLConstants.Excel_Export, {
            EventID: eventInfo.eventID,
            ModuleID: 30,
            iDs: ''
        }
        ).then((res) => {
            const finalObject = JSON.parse(res.data.value);
            if (finalObject) {
                if (finalObject.length > 0) {
                    let header = {};
                    // console.log("finalObject",finalObject);
                    
                    let arrayObj = finalObject.map(item => {
                        let commonObj = {
                            'Participant Name': item.ParticipantName,  
                            'Participant Email': item.ParticipantEmail, 
                            'Contact No': item.ContactNo,
                        }; 
                        if(connectionCount == 1){
                            return {
                                ...commonObj,
                                'Connection 1': item.Connection1,
                                'Connection 1 Contact No': item.Connection1ContactNo,  
                                'Connection 1 Email': item.Connection1Email,                                                       
                            };
                        }else if(connectionCount == 2){
                            return {
                                ...commonObj,
                                'Connection 1': item.Connection1,
                                'Connection 1 Contact No': item.Connection1ContactNo,                                 
                                'Connection 1 Email': item.Connection1Email,          
                                'Connection 2': item.Connection2,
                                'Connection 2 Contact No': item.Connection2ContactNo,    
                                'Connection 2 Email': item.Connection2Email,                                  
                            };
                        }else if(connectionCount == 3){
                            return {
                                ...commonObj,
                                'Connection 1': item.Connection1,
                                'Connection 1 Contact No': item.Connection1ContactNo,
                                'Connection 1 Email': item.Connection1Email,          
                                'Connection 2': item.Connection2,
                                'Connection 2 Contact No': item.Connection2ContactNo,    
                                'Connection 2 Email': item.Connection2Email, 
                                'Connection 3': item.Connection3,
                                'Connection 3 Contact No': item.Connection3ContactNo,
                                'Connection 3 Email': item.Connection3Email,                                
                            };
                        }else if(connectionCount == 4){
                            return {
                                ...commonObj,
                                'Connection 1': item.Connection1,
                                'Connection 1 Contact No': item.Connection1ContactNo,
                                'Connection 1 Email': item.Connection1Email,          
                                'Connection 2': item.Connection2,
                                'Connection 2 Contact No': item.Connection2ContactNo,    
                                'Connection 2 Email': item.Connection2Email, 
                                'Connection 3': item.Connection3,
                                'Connection 3 Contact No': item.Connection3ContactNo,
                                'Connection 3 Email': item.Connection3Email,  
                                'Connection 4': item.Connection4,
                                'Connection 4 Contact No': item.Connection4ContactNo,  
                                'Connection 4 Email': item.Connection4Email,                               
                            };
                        }else if(connectionCount == 5){
                            return {
                                ...commonObj,
                                'Connection 1': item.Connection1,
                                'Connection 1 Contact No': item.Connection1ContactNo,
                                'Connection 1 Email': item.Connection1Email,          
                                'Connection 2': item.Connection2,
                                'Connection 2 Contact No': item.Connection2ContactNo,    
                                'Connection 2 Email': item.Connection2Email, 
                                'Connection 3': item.Connection3,
                                'Connection 3 Contact No': item.Connection3ContactNo,
                                'Connection 3 Email': item.Connection3Email,  
                                'Connection 4': item.Connection4,
                                'Connection 4 Contact No': item.Connection4ContactNo,  
                                'Connection 4 Email': item.Connection4Email,   
                                'Connection 5': item.Connection5,
                                'Connection 5 Contact No': item.Connection5ContactNo,                                
                                'Connection 5 Email': item.Connection5Email,  
                            };
                            
                        }else if(connectionCount == 6){
                            return {
                                ...commonObj,
                                'Connection 1': item.Connection1,
                                'Connection 1 Contact No': item.Connection1ContactNo,
                                'Connection 1 Email': item.Connection1Email,          
                                'Connection 2': item.Connection2,
                                'Connection 2 Contact No': item.Connection2ContactNo,    
                                'Connection 2 Email': item.Connection2Email, 
                                'Connection 3': item.Connection3,
                                'Connection 3 Contact No': item.Connection3ContactNo,
                                'Connection 3 Email': item.Connection3Email,  
                                'Connection 4': item.Connection4,
                                'Connection 4 Contact No': item.Connection4ContactNo,  
                                'Connection 4 Email': item.Connection4Email,   
                                'Connection 5': item.Connection5,
                                'Connection 5 Contact No': item.Connection5ContactNo,                                
                                'Connection 5 Email': item.Connection5Email,  
                                'Connection 6': item.Connection6,
                                'Connection 6 Contact No': item.Connection6ContactNo,     
                                'Connection 6 Email': item.Connection6Email,                            
                            };                            
                        }else if(connectionCount == 7){
                            return {
                                ...commonObj,
                                'Connection 1': item.Connection1,
                                'Connection 1 Contact No': item.Connection1ContactNo,
                                'Connection 1 Email': item.Connection1Email,          
                                'Connection 2': item.Connection2,
                                'Connection 2 Contact No': item.Connection2ContactNo,    
                                'Connection 2 Email': item.Connection2Email, 
                                'Connection 3': item.Connection3,
                                'Connection 3 Contact No': item.Connection3ContactNo,
                                'Connection 3 Email': item.Connection3Email,  
                                'Connection 4': item.Connection4,
                                'Connection 4 Contact No': item.Connection4ContactNo,  
                                'Connection 4 Email': item.Connection4Email,   
                                'Connection 5': item.Connection5,
                                'Connection 5 Contact No': item.Connection5ContactNo,                                
                                'Connection 5 Email': item.Connection5Email,  
                                'Connection 6': item.Connection6,
                                'Connection 6 Contact No': item.Connection6ContactNo,     
                                'Connection 6 Email': item.Connection6Email,    
                                'Connection 7': item.Connection7,
                                'Connection 7 Contact No': item.Connection7ContactNo,    
                                'Connection 7 Email': item.Connection7Email,                                
                            }; 
                        }else if(connectionCount == 8){
                            return {
                                ...commonObj,
                                'Connection 1': item.Connection1,
                                'Connection 1 Contact No': item.Connection1ContactNo,
                                'Connection 1 Email': item.Connection1Email,          
                                'Connection 2': item.Connection2,
                                'Connection 2 Contact No': item.Connection2ContactNo,    
                                'Connection 2 Email': item.Connection2Email, 
                                'Connection 3': item.Connection3,
                                'Connection 3 Contact No': item.Connection3ContactNo,
                                'Connection 3 Email': item.Connection3Email,  
                                'Connection 4': item.Connection4,
                                'Connection 4 Contact No': item.Connection4ContactNo,  
                                'Connection 4 Email': item.Connection4Email,   
                                'Connection 5': item.Connection5,
                                'Connection 5 Contact No': item.Connection5ContactNo,                                
                                'Connection 5 Email': item.Connection5Email,  
                                'Connection 6': item.Connection6,
                                'Connection 6 Contact No': item.Connection6ContactNo,     
                                'Connection 6 Email': item.Connection6Email,    
                                'Connection 7': item.Connection7,
                                'Connection 7 Contact No': item.Connection7ContactNo,    
                                'Connection 7 Email': item.Connection7Email,    
                                'Connection 8': item.Connection8,
                                'Connection 8 Contact No': item.Connection8ContactNo, 
                                'Connection 8 Email': item.Connection8Email,                                   
                            };                            
                        }else if(connectionCount == 9){
                            return {
                                ...commonObj,
                                'Connection 1': item.Connection1,
                                'Connection 1 Contact No': item.Connection1ContactNo,
                                'Connection 1 Email': item.Connection1Email,          
                                'Connection 2': item.Connection2,
                                'Connection 2 Contact No': item.Connection2ContactNo,    
                                'Connection 2 Email': item.Connection2Email, 
                                'Connection 3': item.Connection3,
                                'Connection 3 Contact No': item.Connection3ContactNo,
                                'Connection 3 Email': item.Connection3Email,  
                                'Connection 4': item.Connection4,
                                'Connection 4 Contact No': item.Connection4ContactNo,  
                                'Connection 4 Email': item.Connection4Email,   
                                'Connection 5': item.Connection5,
                                'Connection 5 Contact No': item.Connection5ContactNo,                                
                                'Connection 5 Email': item.Connection5Email,  
                                'Connection 6': item.Connection6,
                                'Connection 6 Contact No': item.Connection6ContactNo,     
                                'Connection 6 Email': item.Connection6Email,    
                                'Connection 7': item.Connection7,
                                'Connection 7 Contact No': item.Connection7ContactNo,    
                                'Connection 7 Email': item.Connection7Email,    
                                'Connection 8': item.Connection8,
                                'Connection 8 Contact No': item.Connection8ContactNo, 
                                'Connection 8 Email': item.Connection8Email,  
                                'Connection 9': item.Connection9,
                                'Connection 9 Contact No': item.Connection9ContactNo,                               
                                'Connection 9 Email': item.Connection9Email,  
                            };
                            
                        }else if(connectionCount == 10){
                            return {
                                ...commonObj,
                                'Connection 1': item.Connection1,
                                'Connection 1 Contact No': item.Connection1ContactNo,
                                'Connection 1 Email': item.Connection1Email,          
                                'Connection 2': item.Connection2,
                                'Connection 2 Contact No': item.Connection2ContactNo,    
                                'Connection 2 Email': item.Connection2Email, 
                                'Connection 3': item.Connection3,
                                'Connection 3 Contact No': item.Connection3ContactNo,
                                'Connection 3 Email': item.Connection3Email,  
                                'Connection 4': item.Connection4,
                                'Connection 4 Contact No': item.Connection4ContactNo,  
                                'Connection 4 Email': item.Connection4Email,   
                                'Connection 5': item.Connection5,
                                'Connection 5 Contact No': item.Connection5ContactNo,                                
                                'Connection 5 Email': item.Connection5Email,  
                                'Connection 6': item.Connection6,
                                'Connection 6 Contact No': item.Connection6ContactNo,     
                                'Connection 6 Email': item.Connection6Email,    
                                'Connection 7': item.Connection7,
                                'Connection 7 Contact No': item.Connection7ContactNo,    
                                'Connection 7 Email': item.Connection7Email,    
                                'Connection 8': item.Connection8,
                                'Connection 8 Contact No': item.Connection8ContactNo, 
                                'Connection 8 Email': item.Connection8Email,  
                                'Connection 9': item.Connection9,
                                'Connection 9 Contact No': item.Connection9ContactNo,                               
                                'Connection 9 Email': item.Connection9Email, 
                                'Connection 10': item.Connection10,
                                'Connection 10 Contact No': item.Connection10ContactNo,  
                                'Connection 10 Email': item.Connection10Email, 
                            };
                        }                        
                      }); 
                     
                    Object.keys(arrayObj[0]).map((key) => {                         
                        header[key] = key;
                    });

                    arrayObj.unshift(header);
                    // console.log("arrayObj",arrayObj);

                    Helper.downloadReport(arrayObj, `ContactList-Report`);
                }
            }
        });
    }

    return (
        <>
            <Box sx={{ width: '100%' }}>
                {loading ? (
                    <Box
                        sx={
                            loading
                                ? { paddingTop: '20%', paddingBottom: '20%' }
                                : ''
                        }
                        className={classes.loader}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Paper sx={{ width: '100%', mb: 2, boxShadow: 'none', maxHeight: 'calc(100vh - 70px)', padding: 2 }}>
                        {contactListData && (
                            <DataList
                                data={contactListData}
                                title={''}
                                showSearch={true}
                                searchLabel={'Search'}
                                showContactListCheckBox={true}
                                contactListChecked={checked}
                                onCheckedContactListChange={onCheckedChange}
                                showPdfExport={true}
                                rowType={'Contact List'}
                                moduleDisplayName={'Contact List'}
                                moduleToShow={true}
                                callPdfExport={handleSelectedExportToPDF}
                                userActivityPDFLoader={userActivityPDFLoader}
                                modPermission={'FULL'}
                                hideAdd={true}
                                hideDelete={true}
                                hideEdit={true}
                                showAlphabetFilter={true}
                                alphabet={alphabet}
                                clickAlphabet={clickAlphabet}
                                handleReset={handleReset}
                                currentAlpha={currentAlpha}
                                showExport={true}
                                callExport={callExport}
                            />)}

                    </Paper>
                )}
                {snackBarProps.openSnack && (
                    <CustomizedSnackbars
                        {...snackBarProps}
                        onClose={() =>
                            setSnackBarProps({ ...snackBarProps, openSnack: false })
                        }></CustomizedSnackbars>
                )}
            </Box>
        </>
    )

}

export default {
    routeProps: {
        path: RouteConstants.CONTACT_LIST,
        component: ContactList,
    },
    name: 'contactList',
};